import React, { useState } from 'react';
import PropTypes from 'prop-types';

const FunnelContext = React.createContext();

const FunnelStore = ({ jobLanguage, jobTitle, uid, children }) => {
  const [answers, setAnswers] = useState([]);
  const [candidate, setCandidate] = useState(null);
  const [hasQuestions, setHasQuestions] = useState(false);
  const [salary, setSalary] = useState(0);
  const [salaryValid, setSalaryValid] = useState('');
  const [questionsValid, setQuestionsValid] = useState('');
  const [step, setStep] = useState(null);
  const [optionalQuestionsEnabled, setOptionalQuestionsEnabled] =
    useState(false);

  return (
    <FunnelContext.Provider
      value={{
        answers,
        candidate,
        hasQuestions,
        jobLanguage,
        jobTitle,
        questionsValid,
        salary,
        salaryValid,
        optionalQuestionsEnabled,
        step,
        uid,
        setAnswers,
        setCandidate,
        setHasQuestions,
        setSalary,
        setSalaryValid,
        setOptionalQuestionsEnabled,
        setStep,
        setQuestionsValid,
      }}
    >
      {children}
    </FunnelContext.Provider>
  );
};

FunnelStore.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  jobLanguage: PropTypes.string.isRequired,
  jobTitle: PropTypes.string.isRequired,
  uid: PropTypes.string.isRequired,
};

export { FunnelContext, FunnelStore };
